@if (scrollY > 300) {
  <button class="btn btn-md btn-secondary scroll-top" (click)="scroll()">
    <span class="scroll-top-text">TOPO</span> &nbsp;<fa-icon [icon]="faCircleArrowUp"></fa-icon>
  </button>
}
